// extracted by mini-css-extract-plugin
export default {"productDescription":"Iba-z","featuredDescription":"Jba-z","description":"Kba-z","more":"Lba-z","descriptionSku":"Mba-z"};